var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// import MaskedInput from 'react-text-mask';
// export const Masked = (props: any) => {
//   const {inputRef, ...other} = props;
//   return (
//     <MaskedInput
//       {...other}
//       // ref={(ref) => {
//       //   inputRef(ref ? ref.inputElement : null);
//       // }}
//       guide={false}
//       mask={[
//         '(',
//         /\d/,
//         /\d/,
//         /\d/,
//         ')',
//         ' ',
//         /\d/,
//         /\d/,
//         /\d/,
//         '-',
//         /\d/,
//         /\d/,
//         /\d/,
//         /\d/,
//       ]}
//     />
//   );
// };
import React from "react";
import MaskedInput from "react-text-mask";
var TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    var onChange = props.onChange, inputRef = props.inputRef, other = __rest(props, ["onChange", "inputRef"]);
    return (_jsx(MaskedInput, __assign({}, other, { guide: false, mask: [
            "(",
            /\d/,
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
        ], ref: function (maskedRef) {
            if (!maskedRef)
                return;
            var inputNode = maskedRef.inputElement;
            // Forward DOM input ref → MUI
            if (typeof ref === "function") {
                ref(inputNode);
            }
            else if (ref) {
                ref.current = inputNode;
            }
        }, onChange: onChange })));
});
export default TextMaskCustom;
